<template>
  <div>
    <v-data-table
      :loading="loadingTable"
      :headers="headers"
      v-model="selectedItens"
      :items="reserves"
      sort-by="calories"
      class="elevation-1"
      :page-count="numberOfPagesPaginate"
      :page="currentPagePaginate"
      :server-items-length="totalStagesPaginate"
      :expanded.sync="expanded"
      show-expand
      :options.sync="options"
      :footer-props="{
        itemsPerPageText: 'Itens por pagina',
        itemsPerPageOptions: [5, 10, 15],
        showFirstLastPage: true,

      }"
      @click:row="selectItem"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Reservas De Grupo</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-text-field
            v-model="search"
            class="mr-2"
            placeholder="Proucurar ID, Hóspede, Empresa, Solicitante ou Localizador externo"
            :append-icon="icons.mdiMagnify"
            single-line
            label="Localizar"
            outlined
            filled
            rounded
            dense
            hide-details
            @click:append="searchItems()"
            @change="searchItems()"
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>

      <template v-slot:item.guests="{ item }">
        {{ allGuests(item) }}
      </template>

      <template v-slot:item.ids="{ item }">
        {{ getIds(item) }}
      </template>

      <template v-slot:item.status="{ item }">
        <div
          v-if="confirmStatus(item) == 'misto'"
          class="d-flex flex-column"
        >
          <v-chip
            v-for="(statusItem, index) in getMixedStatusChips(item)"
            :key="index"
            :color="statusItem.color"
            :text-color="statusItem.textColor"
            x-small
            class="mb-1"
          >
            {{ statusItem.label }}
          </v-chip>
        </div>
        <v-chip
          v-if="confirmStatus(item) == 'confirmed'"
          color="info"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="confirmStatus(item) == 'precheckin'"
          color="#6CBF84"
          text-color="#1F4D2E"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="confirmStatus(item)== 'checkin'"
          color="success"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="confirmStatus(item) == 'checkout'"
          color="error"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="confirmStatus(item) == 'canceled'"
          color="secondary"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="confirmStatus(item) == 'pending'"
          color="orange"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="confirmStatus(item) == 'no-show'"
          color="warning"
        >
          {{ reserved(item) }}
        </v-chip>
      </template>
      <template v-slot:item.room="{ item }">
      </template>
      <template v-slot:item.check_in="{ item }">
        {{ formatDate(item.check_in) }}
      </template>
      <template v-slot:item.check_out="{ item }">
        {{ formatDate(item.check_out) }}
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td
          :colspan="headers.length"
          class="pa-0"
        >
          <v-expand-transition>
            <v-data-table
              :headers="subHeaders"
              :items="item.reserves"
              dense
              hide-default-footer
            >
              <template v-slot:item.status="{ item }">
                <v-chip
                  v-if="item.status == 'confirmed'"
                  color="info"
                >
                  Confirmado
                </v-chip>
                <v-chip
                  v-if="item.status == 'precheckin'"
                  color="#6CBF84"
                  text-color="#1F4D2E"
                >
                  Pré Check-in
                </v-chip>
                <v-chip
                  v-if="item.status == 'checkin'"
                  color="success"
                >
                  Check-in
                </v-chip>
                <v-chip
                  v-if="item.status == 'checkout'"
                  color="error"
                >
                  Check-out
                </v-chip>
                <v-chip
                  v-if="item.status == 'canceled'"
                  color="secondary"
                >
                  Cancelado
                </v-chip>
                <v-chip
                  v-if="item.status == 'pending'"
                  color="orange"
                >
                  Pendente
                </v-chip>
                <v-chip
                  v-if="item.status == 'no-show'"
                  color="warning"
                >
                  No-Show
                </v-chip>
              </template>

              <template v-slot:item.guests="{ item }">
                {{ allGuests(item) }}
              </template>

              <template v-slot:item.check_in="{ item }">
                {{ formatDate(item.check_in) }}
              </template>

              <template v-slot:item.check_out="{ item }">
                {{ formatDate(item.check_out) }}
              </template>
            </v-data-table>
          </v-expand-transition>
        </td>
      </template>

      <template v-slot:no-data>
        <NoDataTable></NoDataTable>
      </template>
      <template v-slot:loading>
        Carregando...
      </template>
    </v-data-table>

    <v-card class="mt-2">
      <v-card-subtitle>
        Clique no registro para visualizar a observação:
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            class="text-center"
          >
            <p v-text="selectedItens.length > 0 ? selectedItens[0].obs : ''"></p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

// import MsgDelete from '@/components/MsgDelete.vue'
import {
  mdiClose,
  mdiDeleteOutline,
  mdiPencilOutline,
  mdiPlus,
  mdiCloseCircleOutline,
  mdiPrinter,
  mdiCurrencyUsd,
  mdiFilter,
  mdiMessageOutline,
} from '@mdi/js'
import { mapActions, mapMutations } from 'vuex'
import NoDataTable from '@/components/NoDataTable.vue'
import DialogReserve from './_components/DialogReserve.vue'
import BarTitleDialog from '@/components/BarTitleDialog.vue'

export default {
  components: {
    NoDataTable,
    DialogReserve,
    BarTitleDialog,
  },
  data: () => ({
    selectedItens: [],
    loadingUserAdmin: false,
    userAdmin: false,
    cancelCashId: null,
    loadingOpenedCashs: false,
    cashItems: [],
    loadingCancel: false,
    justifyCancel: '',
    dialogCancel: false,
    dialogFilter: false,
    filter: {},
    search: '',
    dialogNewGuest: false,
    loadingTable: false,
    totalStagesPaginate: 0,
    numberOfPagesPaginate: 0,
    currentPagePaginate: 0,
    dialogDelete: false,
    dialog: false,
    loading: false,
    itemsStatus: [
      { text: 'Checkin', value: 'checkin' },
      { text: 'Checkout', value: 'checkout' },
      { text: 'Cancelado', value: 'canceled' },
      { text: 'Confirmado', value: 'confirmed' },
      { text: 'Pré Check-in', value: 'precheckin' },
      { text: 'Pendente', value: 'pending' },
      { text: 'No-Show', value: 'no-show' },
      { text: 'Misto', value: 'misto' },
    ],
    headers: [
      {
        text: 'ID',
        align: 'center',
        value: 'ids',
      },
      {
        text: 'EMPRESA',
        value: 'company.fantasy_name',
        sortable: false,
      },

      {
        text: 'SOLICITANTE',
        value: 'requester',
        sortable: false,
      },

      {
        text: 'CATEGORIA',
        value: 'room_category.description',
        sortable: false,
      },
      {
        text: 'QUARTOS',
        value: 'qtd_room',
      },
      {
        text: 'CHECKIN',
        value: 'check_in',
        sortable: false,
      },
      {
        text: 'CHECKOUT',
        value: 'check_out',
        sortable: false,
      },
      {
        text: 'STATUS',
        value: 'status',
        sortable: false,
      },
    ],
    subHeaders: [
      {
        text: 'ID',
        align: 'start',
        value: 'id',
      },
      {
        text: 'EMPRESA',
        value: 'company.fantasy_name',
      },
      {
        text: 'HÓSPEDES',
        value: 'guests',
      },
      {
        text: 'CHECKIN',
        value: 'check_in',
      },
      {
        text: 'CHECKOUT',
        value: 'check_out',
      },
      {
        text: 'STATUS',
        value: 'status',
      },

    ],
    reserves: [],
    editedIndex: -1,
    editedItem: {},
    editedDefault: {
      check_in: '',
      check_out: '',
      company_id: '',
      room: [],
      tariff_manual: 'not',
      with_iss: 'not',
    },
    options: {},
    tab: null,
    items: [
      {
        tab: 'One',
        content: 'Tab 1 Content',
      },
      {
        tab: 'Two',
        content: 'Tab 2 Content',
      },
    ],
    icons: {
      mdiPencilOutline,
      mdiDeleteOutline,
      mdiPlus,
      mdiClose,
      mdiCloseCircleOutline,
      mdiPrinter,
      mdiCurrencyUsd,
      mdiFilter,
      mdiMessageOutline,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Nova Reserva' : 'Editar Reserva'
    },
    bagFilter() {
      if (this.filter.status == null) {
        delete this.filter.status
      }

      return Object.keys(this.filter).length
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },
    options: {
      handler() {
        this.initialize()
      },
    },
  },

  created() {
    this.initialize()

    // carrega o select rooms do dialog reserve
    this.loadRooms()

    // carrega o select categoria de quartos do dialog reserve
    this.loadRoomCategories()

    // carrega o select tariffs
    this.loadTariffs()
  },

  methods: {

    ...mapActions('reserve', [
      'getAll',
      'store',
      'update',
      'printVoucher',
      'getReserveItems',
      'cancelReserve',
      'getOpenedCashs',
      'getUser',
      'getCompletedReserve',
      'getGroupReserve',
    ]),

    initialize() {
      this.loadingTable = true
      this.selectedItens = []
      const { page, itemsPerPage } = this.options

      const payload = {
        itemsPerPage: itemsPerPage || 10,
        page,
        search: this.search,
      }
      this.getGroupReserve(payload)
        .then(response => {
          this.reserves = response.data.data
          this.totalStagesPaginate = response.data.total
          this.numberOfPagesPaginate = response.data.last_page
          this.currentPagePaginate = response.data.current_page
        })
        .finally(() => {
          this.loadingTable = false
        })
    },
    searchItems() {
      this.options = {}
      this.initialize()
    },
    requester(item) {
      if (item.requester == null) {
        if (item.company) {
          return item.company.fantasy_name
        } if (item.guest.length > 0) {
          return item.guest[0].name
        } if (item.guest_unknown.length > 0) {
          return item.guest_unknown[0].name
        }
      } else {
        return item.requester
      }
    },

    firstGuest(item) {
      if (item.guest.length > 0) {
        return item.guest[0].name
      } if (item.guest_unknown.length > 0) {
        return item.guest_unknown[0].name
      }

      return ''
    },

    allGuests(item) {
      const guests = item.guest
      const guestsUnknown = item.guest_unknown

      if (guests.length > 0) {
        return guests.map(guest => guest.name).join(', ')
      } if (guestsUnknown.length > 0) {
        return guestsUnknown.map(guest => guest.name).join(', ')
      }
    },

    reserved(item) {
      const status = this.confirmStatus(item)
      switch (status) {
        case 'confirmed':
          return 'Confirmado'
        case 'precheckin':
          return 'Pré Check-in'
        case 'checkin':
          return 'Checkin'
        case 'checkout':
          return 'Checkout'
        case 'canceled':
          return 'Cancelado'
        case 'pending':
          return 'Pendente'
        case 'no-show':
          return 'No-Show'
      }
    },

    printItem(reserve) {
      reserve.loading_print = true
      this.printVoucher(reserve)
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', 'voucher.pdf')
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch(response => {
          console.log(response)
        })
        .finally(() => {
          this.reserves.forEach(item => {
            item.loading_print = false
          })

          // armegagem para força a reação do vue
          const backup = this.reserves
          this.reserves = []
          this.reserves = backup
        })
    },

    formatDate(date) {
      if (date) {
        const result = new Date(date)

        return result.toLocaleDateString('pt-BR', {
          timeZone: 'UTC',
        })
      }
    },
    selectItem(item) {
      this.selectedItens = []
      this.selectedItens.push(item)
      console.log(this.selectedItens)
    },
    getIds(item) {
      const ids = []
      item.reserves.forEach(reserve => {
        ids.push(reserve.id)
      })

      return ids.join(' - ')
    },
    confirmStatus(item) {
      const { reserves } = item
      const total = reserves.length
      const status = {
        checkin: 0,
        checkout: 0,
        canceled: 0,
        'no-show': 0,
        confirmed: 0,
        precheckin: 0,
        pending: 0,
      }

      reserves.forEach(reserve => {
        if (reserve.status == 'checkin') {
          status.checkin++
        } else if (reserve.status == 'checkout') {
          status.checkout++
        } else if (reserve.status == 'canceled') {
          status.canceled++
        } else if (reserve.status == 'no-show') {
          status['no-show']++
        } else if (reserve.status == 'precheckin') {
          status.precheckin++
        } else if (reserve.status == 'pending') {
          status.pending++
        } else if (reserve.status == 'confirmed') {
          status.confirmed++
        }
      })

      // Se todas estão canceladas, retorna cancelado
      if (status.canceled === total) {
        return 'canceled'
      }

      // Ignora as canceladas e calcula baseado nas não-canceladas
      const totalNonCanceled = total - status.canceled

      if (status.checkin === totalNonCanceled) {
        return 'checkin'
      } if (status.checkout === totalNonCanceled) {
        return 'checkout'
      } if (status['no-show'] === totalNonCanceled) {
        return 'no-show'
      } if (status.precheckin === totalNonCanceled) {
        return 'precheckin'
      } if (status.pending === totalNonCanceled) {
        return 'pending'
      } if (status.confirmed === totalNonCanceled) {
        return 'confirmed'
      }

      // Status misto (combinação de diferentes status, ignorando cancelados)
      return 'misto'
    },

    getMixedStatusChips(item) {
      const { reserves } = item
      const status = {
        checkin: 0,
        checkout: 0,
        'no-show': 0,
        confirmed: 0,
        precheckin: 0,
        pending: 0,
      }

      // Conta os status ignorando cancelados
      reserves.forEach(reserve => {
        if (reserve.status == 'checkin') {
          status.checkin++
        } else if (reserve.status == 'checkout') {
          status.checkout++
        } else if (reserve.status == 'no-show') {
          status['no-show']++
        } else if (reserve.status == 'precheckin') {
          status.precheckin++
        } else if (reserve.status == 'pending') {
          status.pending++
        } else if (reserve.status == 'confirmed') {
          status.confirmed++
        }
      })

      // Calcula o total de não cancelados
      const totalNonCanceled = status.confirmed + status.checkin + status.checkout + status['no-show'] + status.precheckin + status.pending

      // Monta array de chips com os status que existem
      const chips = []

      if (status.confirmed > 0) {
        chips.push({
          color: 'info',
          label: `${status.confirmed} Confirmado${status.confirmed > 1 ? 's' : ''}`,
        })
      }

      if (status.precheckin > 0) {
        chips.push({
          color: '#6CBF84',
          textColor: '#1F4D2E',
          label: `${status.precheckin} Pré Check-in${status.precheckin > 1 ? 's' : ''}`,
        })
      }

      if (status.checkin > 0) {
        chips.push({
          color: 'success',
          label: `${status.checkin} Check-in${status.checkin > 1 ? 's' : ''}`,
        })
      }

      if (status.checkout > 0) {
        chips.push({
          color: 'error',
          label: `${status.checkout} Check-out${status.checkout > 1 ? 's' : ''}`,
        })
      }

      if (status.pending > 0) {
        chips.push({
          color: 'orange',
          label: `${status.pending} Pendente${status.pending > 1 ? 's' : ''}`,
        })
      }

      if (status['no-show'] > 0) {
        chips.push({
          color: 'warning',
          label: `${status['no-show']} No-Show${status['no-show'] > 1 ? 's' : ''}`,
        })
      }

      return chips
    },

  },
}
</script>

  <style scoped>
  .card-tab {
    min-height: 420px;
    min-width: 736px;
  }

  .tool_table_fam {
    height: 50px;
  }
</style>
